import { geocodingServices } from 'src/services';
import { setValuesAndOpenAlertModalReducer } from 'src/store';
import { typeCoords } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

export const useGetCurrentPosition = (gettingAddress: boolean, showError: boolean) => {
    const [address, setAddress] = useState('');
    const [userCoords, setUserCoords] = useState<typeCoords | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(geoPosition => {
            const position: typeCoords = {
                lat: geoPosition.coords.latitude,
                lng: geoPosition.coords.longitude
            };
            setUserCoords(position);
        }, error => {
            console.log(error);
            if (showError) {
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'alert',
                    title: 'No se pudo obtener localización',
                    message: 'No hay permiso del dispositivo para que la aplicación utilice la localización actual',
                    animation: 2
                }));
            } else {
                console.log('No hay permiso del dispositivo para que la aplicación utilice la localización actual');
            }
        }, { enableHighAccuracy: true });
    }, []);

    useEffect(() => {
        if (!gettingAddress || !userCoords) {
            return;
        }
        geocodingServices.GetAddressFromCoordinates(userCoords).then(response => {
            if (!response.success || !response.data?.address) {
                setAddress('(Dirección no encontrada)');
                return;
            }
            setAddress(response.data.address);
        });
    }, [gettingAddress, userCoords]);

    return { address, userCoords };
}
